module.exports = __webpack_public_path__ + "img/graphic-designer.fc995e87.png";